<template>
    <!--********** FINESTRA MODALE **********-->
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content modal-large" v-if="formAttivo">
            <article class="message">
                <div class="message-body" v-if="!statoElencoListini">

                    <!--********** BOTTONI DI GESTIONE VOCE **********-->
                    <div class="columns is-mobile">
                        <div class="column">
                            <div class="field buttons">
                                <button class="button" @click="bSeleziona('annulla')">Annulla</button>
                            </div>                
                        </div>

                        <div class="column">
                            <div class="field buttons is-right">
                                <button class="button is-primary" @click="bSeleziona('salva')">Salva</button>
                            </div>
                        </div>
                    </div>

                    <!--********** FORM VOCE **********-->
                    <div class="righe-preventivo">
                        <div class="columns is-vcentered">
                            <div class="column is-2">
                                Elemento
                            </div>
                            <div class="column is-2">
                                <CampoTendina @valoreCambiato="(valore)=>elementoModifica(valore, 'tipo')"
                                    :valore=String(vocePreventivo.tipo)
                                    :disabilitato=props.tipoDisabilitato
                                    idTendina="tipiVocePreventivo"/>
                            </div>
                            <div class="column is-2" v-if="vocePreventivo.tipo == 'Articolo'">
                                <a @click="bScegliArticolo()" title="Listino"> {{dbListini[vocePreventivo.listino].informazioni.nome}} </a>
                            </div>
                            <div class="column is-2" v-if="vocePreventivo.tipo == 'Articolo'">
                                <a @click="bScegliArticolo()" title="Articolo"> {{vocePreventivo.codice}} </a>
                            </div>
                            <div class="column is-2" v-if="vocePreventivo.tipo == 'Articolo'">
                                Bene significativo: 
                            </div>
                            <div class="column is-2" v-if="vocePreventivo.tipo == 'Articolo'">
                                <CampoTendina @valoreCambiato="(valore)=>elementoModifica(valore, 'beneSignificativo')"
                                    :valore="vocePreventivo.beneSignificativo?String(vocePreventivo.beneSignificativo):'No'"
                                    idTendina="vocePreventivo.beneSignificativo"/>
                            </div>
                        </div>
                        <!-- Articolo -->
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Articolo' || vocePreventivo.tipo == 'Nota'">
                            <div class="column is-2">
                                Descrizione
                            </div>
                            <div class="column is-10">
                                <textarea class="textarea" placeholder="Descrizione"  rows="7" v-model="vocePreventivo.descrizione"></textarea>
                            </div>
                        </div>
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Articolo'">
                            <div class="column is-2">
                                Quantità e listino
                            </div>
                            <div class="column is-2">
                                <input class="input has-text-centered" type="text" v-model="vocePreventivo.unita" title="Unità di misura">
                            </div>
                            <div class="column is-2">
                                <CampoNumero @valoreCambiato="elementoModifica"
                                    :valore=parseFloat(vocePreventivo.quantita)
                                    identificativo="quantita"
                                    :decimali = 2
                                    tipo="Decimale"/>
                            </div>
                            <div class="column is-4">
                                <CampoPrListinoDoppio @valoreCambiato="elementoModifica"
                                    :valore=arrayPrListino()
                                    identificativo="listinoAcquistoVendita"/>
                            </div>
                        </div>
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Articolo'">
                            <div class="column is-2">
                                Acquisto
                            </div>
                            <div class="column is-2">
                                <CampoRicarico @valoreCambiato="elementoModifica"
                                    :valore=vocePreventivo.rcAcq?vocePreventivo.rcAcq:[0,0,0]
                                    identificativo="rcAcq"
                                    />
                            </div>
                            <div class="column is-2">
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Costo unitario: {{ generaStringa(prAcquisto, '0,00') }}
                                </div>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Costo totale: {{ generaStringa(prAcquisto*vocePreventivo.quantita, '0,00') }}
                                </div>
                            </div>
                        </div>
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Articolo'">
                            <div class="column is-2">
                                Vendita
                            </div>
                            <div class="column is-2">
                                <CampoTendina
                                    @valoreCambiato="(valore)=>elementoModifica(valore, 'tipoRicaricoSconto')"
                                    :valore=String(vocePreventivo.tipoRicaricoSconto)
                                    :elencoValori=elencoValoriRicaricoScontoTendina()
                                    />
                            </div>
                            <div class="column is-2">
                                <input type="radio" value=true v-model="vocePreventivo.scVisibile" @click="elementoModifica(null, 'scVisibile')"/>
                                <label>Visibile</label>
                                &nbsp;&nbsp;
                                <input type="radio" value=false v-model="vocePreventivo.scVisibile" @click="elementoModifica(null, 'scVisibile')"/>
                                <label>Nascosto</label>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Prezzo unitario: {{ generaStringa(prVendita, '0,00') }}
                                </div>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Prezzo totale: {{  generaStringa(prVendita*vocePreventivo.quantita, '0,00') }}
                                </div>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Ricarico: {{  generaStringa((prVendita/prAcquisto-1)*100, '0,00') }} %
                                </div>
                            </div>
                        </div>
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Articolo'">
                            <div class="column is-2">
                                Note
                            </div>
                            <div class="column is-10">
                                <textarea class="textarea" placeholder="Note"  rows="3" v-model="vocePreventivo.note"></textarea>
                            </div>
                        </div>
                        <!-- Titolo -->
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Titolo'">
                            <div class="column is-2">
                                Codice
                            </div>
                            <div class="column is-10">
                                <input class="input" type="text" v-model="vocePreventivo.codice">
                            </div>
                        </div>
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Titolo'">
                            <div class="column is-2">
                                Titolo
                            </div>
                            <div class="column is-10">
                                <textarea class="textarea" placeholder="Titolo"  rows="2" v-model="vocePreventivo.titolo"></textarea>
                            </div>
                        </div>
                        <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Titolo'">
                            <div class="column is-2">
                                Sottotitolo
                            </div>
                            <div class="column is-10">
                                <textarea class="textarea" placeholder="Sottotitolo"  rows="5" v-model="vocePreventivo.sottotitolo"></textarea>
                            </div>
                        </div>
                        <!-- <div class="columns is-vcentered" v-if="vocePreventivo.tipo == 'Articolo'">
                            <div class="column is-2">
                                Rateizzazione
                            </div>
                            <div class="column is-2">
                                <CampoTendina
                                    @valoreCambiato="(valore)=>elementoModifica(valore, 'tipoRicaricoSconto')"
                                    :valore=String(vocePreventivo.tipoRicaricoSconto)
                                    :elencoValori=elencoValoriRicaricoScontoTendina()
                                    />
                            </div>
                            <div class="column is-2">
                                <input type="radio" value=true v-model="vocePreventivo.scVisibile" @click="elementoModifica(null, 'scVisibile')"/>
                                <label>Visibile</label>
                                &nbsp;&nbsp;
                                <input type="radio" value=false v-model="vocePreventivo.scVisibile" @click="elementoModifica(null, 'scVisibile')"/>
                                <label>Nascosto</label>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Prezzo unitario: {{ generaStringa(prVendita, '0,00') }}
                                </div>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Prezzo totale: {{  generaStringa(prVendita*vocePreventivo.quantita, '0,00') }}
                                </div>
                            </div>
                            <div class="column is-2">
                                <div class="container">
                                    Ricarico: {{  generaStringa((prVendita/prAcquisto-1)*100, '0,00') }} %
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>
                <div class="message-body" v-if="statoElencoListini">
                    <ElencoListini
                        :listinoAttivo=statoElencoListini.listinoAttivo
                        :testo-da-cercare=testoDaCercareElencoListini
                        :modalita-selezione="true"
                        @elementoSelezionato="voceListinoSelezionata"
                        @statoInterfacciaCambiato="statoElencoListiniCambiato"/>
                </div>
            </article>
        </div>
    </div>
</template>

<script setup>
    import CampoTendina from "./CampoTendina.vue";
    import ElencoListini from "./ElencoListini.vue"
    import CampoPrListinoDoppio from "./CampoPrListinoDoppio.vue";
    import CampoNumero from "./CampoNumero.vue";
    import CampoRicarico from "./CampoRicarico.vue";
    import { defineProps, defineEmits, ref, nextTick } from "vue";
    import { aggiungiInfoDB, dbListini, leggiInfoDBRaw } from "../code/gestioneDB";
    import { clonaOggetto, generaStringa, prezzoVocePreventivo, costoVocePreventivo } from "../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        azione: {
            type: String,
            required: true
        },
        tipoDisabilitato: {
            type: Boolean,
            default: false
        },
        elencoValoriRicaricoSconto: {
            type: Object,
            required: false,
            default: () => ({})
        },
        vocePreventivo: {
            type: Object,
            required: false,
            default: () => ({})
        }
    });
    // const emit = defineEmits(['elementoModificato', 'annullaModifica']);
    const emit = defineEmits(['elementoModificato']);

    // VARIABILI DEL COMPONENTE
    const vocePreventivo = ref(null);       // E' una copia della Voce Preventivo selezionata
    const statoElencoListini = ref(null);   // null = Non mostrare l'elenco dei listini; {}
    const prAcquisto = ref(null);
    const prVendita = ref(null);
    const formAttivo = ref(true);                   // Serve a spegnere il form per imporre il reset di tutta l'interfaccia
    const testoDaCercareElencoListini = ref(null);

    // SETUP DEL COMPONENTE
    setupFormVocePreventivo();

    // FUNZIONI DEL COMPONENTE
    async function setupFormVocePreventivo() {
        vocePreventivo.value = {};
        vocePreventivo.value = clonaOggetto(props.vocePreventivo);
        // arrayRcAcq.value = creaArrayRcAcq();
        // arrayRcVen.value = creaArrayRcVen();
        if (vocePreventivo.value.tipo == 'Articolo') {
            prAcquisto.value = costoVocePreventivo(vocePreventivo.value);
            prVendita.value = prezzoVocePreventivo(vocePreventivo.value, props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto]);
        }
        resetForm();
    }

    function elementoModifica(valore, etichetta) {
        let tipoModificato = false;
        switch (etichetta) {
            case 'tipo':
                tipoModificato = true;
                vocePreventivo.value = {};
                // vocePreventivo.value.info = props.vocePreventivo.info;
                aggiungiInfoDB(vocePreventivo.value, leggiInfoDBRaw(props.vocePreventivo));
                vocePreventivo.value.ordine = props.vocePreventivo.ordine;
                if (valore == 'Articolo'){
                    vocePreventivo.value.listino = 1;
                    bScegliArticolo();
                }
                vocePreventivo.value[etichetta] = valore;
                break;
            case 'listinoAcquistoVendita':
                if (valore.length==1) {
                    vocePreventivo.value.prListino = valore[0];
                    delete vocePreventivo.value.prListinoAcq;
                    delete vocePreventivo.value.prListinoVen;
                } else {
                    vocePreventivo.value.prListinoAcq = valore[0];
                    vocePreventivo.value.prListinoVen = valore[1];
                    delete vocePreventivo.value.prListino;
                }
                break;
            case 'quantita':
                vocePreventivo.value[etichetta] = parseFloat(valore);
                break;
            case 'scVisibile':
                vocePreventivo.value[etichetta] = !vocePreventivo.value[etichetta];
                break
            case 'beneSignificativo':
                if (valore == 'No') {
                    vocePreventivo.value[etichetta] ? delete vocePreventivo.value[etichetta] : null;
                } else {
                    vocePreventivo.value[etichetta] = valore;
                }
                break
            default:
                vocePreventivo.value[etichetta] = valore;
        }
        if (vocePreventivo.value.tipo == 'Articolo' && !tipoModificato) {
            // Se la voce è di tipo Articolo, aggiorna i prezzi
            prAcquisto.value = costoVocePreventivo(vocePreventivo.value);
            prVendita.value = prezzoVocePreventivo(vocePreventivo.value, props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto]);
        }
        resetForm();
    }

    function bSeleziona(comando) {
        switch (comando) {
            case 'annulla':
                emit('elementoModificato', 'annulla', vocePreventivo.value);
                break;
            case 'salva':
                emit('elementoModificato', props.azione, vocePreventivo.value);
                break;
        }
    }

    async function resetForm() {
        // Resetta l'interfaccia del form per permettere l'aggiornamento
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

    function bScegliArticolo() {
        statoElencoListini.value = {testoRicercaListini: '', listinoAttivo: vocePreventivo.value.listino};
    }

    async function statoElencoListiniCambiato(tempStato) {
        testoDaCercareElencoListini.value = tempStato.testoRicercaListini;
        statoElencoListini.value = null;
        await nextTick();
        statoElencoListini.value = tempStato;
    }

    function voceListinoSelezionata(tempArticolo){
        vocePreventivo.value.listino = tempArticolo.idListino;
        vocePreventivo.value.codice = tempArticolo.idArticoloListino;
        // vocePreventivo.value.descrizione = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].descrizione;
        // vocePreventivo.value.unita = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].unita;
        if (dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].descrizione) vocePreventivo.value.descrizione = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].descrizione;
        if (dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].unita) vocePreventivo.value.unita = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].unita;
        // Pulisco i prezzi di listino vecchi
        if (vocePreventivo.value.prListinoAcq) delete vocePreventivo.value.prListinoAcq;
        if (vocePreventivo.value.prListinoVen) delete vocePreventivo.value.prListinoVen;
        if (vocePreventivo.value.prListino) delete vocePreventivo.value.prListino;
        if (dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].prListino) {
            vocePreventivo.value.prListino = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].prListino;
        } else if (dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].prListinoAcq &&
            dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].prListinoVen) {
            vocePreventivo.value.prListinoAcq = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].prListinoAcq;
            vocePreventivo.value.prListinoVen = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].prListinoVen;
        }
        if (dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].rcAcq) {
            vocePreventivo.value.rcAcq = dbListini.value[tempArticolo.idListino].articoli[tempArticolo.idArticoloListino].rcAcq;
        } else {
            vocePreventivo.value.rcAcq = dbListini.value[tempArticolo.idListino].informazioni.rcAcq;
        }
        // Riempio le proprietà che mancano se la voce è appena stata creata
        if (!vocePreventivo.value.tipoRicaricoSconto) {
            vocePreventivo.value.tipoRicaricoSconto = 0;
        }
        if (!vocePreventivo.value.quantita) {
            vocePreventivo.value.quantita = 1;
        }
        if (!vocePreventivo.value.scVisibile) {
            vocePreventivo.value.scVisibile = false;
        }

        statoElencoListini.value = null;
        prAcquisto.value = costoVocePreventivo(vocePreventivo.value);
        prVendita.value = prezzoVocePreventivo(vocePreventivo.value, props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto]);
        resetForm();
    }

    function arrayPrListino() {
        let tempArray = [];
        if ('prListino' in vocePreventivo.value) {
            tempArray.push(vocePreventivo.value.prListino);
        } else {
            tempArray.push(vocePreventivo.value.prListinoAcq);
            tempArray.push(vocePreventivo.value.prListinoVen);
        }
        return tempArray;
    }

    // function prezzoAcquisto() {
    //     return costoVocePreventivo(vocePreventivo.value);

        // let tempPrezzoAcquisto = 0;
        // if ('prListino' in vocePreventivo.value) {
        //     tempPrezzoAcquisto = vocePreventivo.value.prListino;
        // } else {
        //     tempPrezzoAcquisto = vocePreventivo.value.prListinoAcq;
        // }
        // if (vocePreventivo.value.rcAcq) {
        //     tempPrezzoAcquisto = tempPrezzoAcquisto*(1+vocePreventivo.value.rcAcq[0])*(1+vocePreventivo.value.rcAcq[1])*(1+vocePreventivo.value.rcAcq[2]);
        // }
        // tempPrezzoAcquisto = tempPrezzoAcquisto*vocePreventivo.value.quantita;
        // return arrotonda(tempPrezzoAcquisto, 2);
    // }

    // function prezzoVendita() {
    //     return prezzoVocePreventivo(vocePreventivo.value, props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto]);

        // let tempPrezzoVendita = 0;
        // if (props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto].fonte=='Costo') {
        //     tempPrezzoVendita = prezzoAcquisto();
        // } else {
        //     if ('prListino' in vocePreventivo.value) {
        //         tempPrezzoVendita = vocePreventivo.value.prListino;
        //     } else {
        //         tempPrezzoVendita = vocePreventivo.value.prListinoVen;
        //     }
        // }
        // tempPrezzoVendita = tempPrezzoVendita*vocePreventivo.value.quantita;
        // // Applico lo sconto prendendo le aliquote da tipoRicaricoSconto
        // tempPrezzoVendita = tempPrezzoVendita*(1+props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto].aliquote[0])*
        //     (1+props.elencoValoriRicaricoSconto[vocePreventivo.value.tipoRicaricoSconto].aliquote[1]);
        // return tempPrezzoVendita;
    // }

    function elencoValoriRicaricoScontoTendina() {
        let tempArray = [];
        for (const sc in props.elencoValoriRicaricoSconto) {
            tempArray.push({valore: sc, testo: props.elencoValoriRicaricoSconto[sc].descrizione});
        }
        // for (let i=0; i<props.elencoValoriRicaricoSconto.length; i++) {
        //     tempArray.push({valore: props.elencoValoriRicaricoSconto[i].info.id, testo: props.elencoValoriRicaricoSconto[i].descrizione});
        // }
        return tempArray;
    }

</script>

<style scoped>
    .righe-preventivo .columns {
        margin-bottom: 0.5rem;
        /* padding-bottom: 0.5rem; */
        border-bottom: 1px solid #e5e5e5;
    }
    .righe-preventivo .column {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
</style>